import React from 'react';
import { SxProps, Theme } from '@mui/material';

import { PropertySelectField } from '@paragon/client-tools';

export type LoadDistribution = 'Uniform' | 'Trapezoidal' | 'Concentrated';

const loadDistributionOptions: LoadDistribution[] = ['Uniform', 'Trapezoidal', 'Concentrated'];

interface LoadDistributionSelectProps {
  loadDistribution: LoadDistribution;
  submit: (loadDistribution: LoadDistribution) => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export function LoadDistributionSelect(props: LoadDistributionSelectProps) {
  const { disabled, loadDistribution, sx, submit } = props;
  return (
    <PropertySelectField
      sx={sx}
      property="Load Distribution"
      value={loadDistribution}
      options={loadDistributionOptions}
      submit={submit}
      disabled={disabled}
    />
  );
}
